export default "__VITE_ASSET__BYRNsVig__"